import Vue from 'vue';

export default Vue.filter('number', (value) => {
  return (value || '').toLocaleString('pt-BR');
});
